var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "pa-3", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "mt-1" },
        [
          _c(
            "v-col",
            { staticClass: "pa-0 mt-n3", attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                { attrs: { width: "100%", flat: "" } },
                [
                  _c(
                    "v-toolbar-title",
                    [
                      _c("div", { staticClass: "float-left mr-4" }, [
                        _vm._v("Service Queues"),
                      ]),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass:
                                            "float-left mr-5 elevation-0 primary--text",
                                          attrs: {
                                            fab: "",
                                            text: "",
                                            "x-small": "",
                                            color: "default",
                                            loading: !_vm.queuesLoaded,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.refreshQueues()
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            size: "24",
                                            color: "primary",
                                          },
                                        },
                                        [_vm._v("refresh")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [_c("span", [_vm._v("Refresh Queues")])]
                      ),
                      _vm.queueEditor
                        ? _c(
                            "div",
                            { staticClass: "float-left ml-2 mr-4" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    disabled: !_vm.enablePauseAll(),
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSelected(false)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      "Pause " +
                                        (_vm.selectedQueues.length > 0
                                          ? "Selected "
                                          : "All ") +
                                        "Queues"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.queueEditor
                        ? _c(
                            "div",
                            { staticClass: "float-left" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    disabled: !_vm.enableResumeAll(),
                                    color: "success",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateSelected(true)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      "Resume " +
                                        (_vm.selectedQueues.length > 0
                                          ? "Selected "
                                          : "All ") +
                                        "Queues"
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("v-spacer"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "8" } },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.tableHeaders,
                  items: _vm.queues,
                  "item-key": "name",
                  "show-select": _vm.queueEditor,
                  "items-per-page": 100,
                  loading: !_vm.queuesLoaded,
                  "hide-default-footer": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.status",
                    fn: function ({ item }) {
                      return [
                        _c("div", { staticClass: "border-left" }, [
                          _vm._v(_vm._s(_vm.getStatusName(item.status))),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.action",
                    fn: function ({ item }) {
                      return [
                        _vm.queuesLoaded
                          ? _c(
                              "div",
                              [
                                item.status === 0
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          color: "primary",
                                          enabled: _vm.queueEditor,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateOne(
                                              false,
                                              item.name
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Pause Queue")]
                                    )
                                  : _c(
                                      "v-btn",
                                      {
                                        attrs: { small: "", color: "success" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updateOne(
                                              true,
                                              item.name
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Resume Queue")]
                                    ),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              [
                                _c("v-skeleton-loader", {
                                  staticClass: "mb-n1",
                                  attrs: { type: "text" },
                                }),
                              ],
                              1
                            ),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selectedQueues,
                  callback: function ($$v) {
                    _vm.selectedQueues = $$v
                  },
                  expression: "selectedQueues",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }